import { AxiosError } from 'axios';
import { useState, useCallback, useEffect } from 'react';
import { IApplicantUserData } from '../../models/jobs/applicantsData.model';
import {
  ErrorHttpResponse,
  HttpConfig,
  SuccessHttpResponse,
} from '../../models/https';
import useHttps from '../useHttps';

const useGetApplicantData = (applicantId: string, run: boolean = false) => {
  const request = useHttps();
  const [loading, setLoading] = useState(false);
  const [applicantData, setApplicantData] = useState<IApplicantUserData | null>(
    null
  );
  const [failed, setFailed] = useState(false);

  const onGetApplicantDataError = useCallback(
    (err: AxiosError<ErrorHttpResponse>) => {
      setFailed(true);
      console.error(
        err?.message ?? 'Something went wrong while fetching applicant data'
      );
    },
    []
  );

  const onGetApplicantDataSuccess = useCallback(
    ({ data, message }: SuccessHttpResponse<IApplicantUserData>) => {
      setApplicantData(data);
      setFailed(false);
    },
    []
  );

  const getApplicantData = useCallback(
    async (applicantIdBackup: string): Promise<void> => {
      const url: HttpConfig = {
        url: `auth-service/users/${applicantIdBackup}`,
        method: 'get',
      };

      return await request(
        url,
        onGetApplicantDataSuccess,
        setLoading,
        onGetApplicantDataError
      );
    },
    [request, onGetApplicantDataSuccess, onGetApplicantDataError]
  );

  useEffect(() => {
    if (run) {
      getApplicantData(applicantId);
    }
  }, [run, getApplicantData, applicantId]);

  return {
    failed,
    loading,
    applicantData,
    getApplicantData,
  };
};

export default useGetApplicantData;
